import img1 from "./0603497816415.jpg";
import img1B from "./0603497816415B.jpg";
import img2 from "./0603497818563.jpg";
import img2B from "./0603497818563B.jpg";
import img3 from "./0603497818570.jpg";
import img3B from "./0603497818570B.jpg";
import img4 from "./0603497818587.jpg";
import img4B from "./0603497818587B.jpg";
import img5 from "./0603497818594.jpg";
import img5B from "./0603497818594B.jpg";
import img6 from "./5021732510549.jpg";
import img6B from "./5021732510549B.jpg";
import img0075678601453 from "./0075678601453.jpeg";
import img0603497820375 from "./0603497820375.jpg";
import img5021732537720 from "./5021732537720.jpg";
import img5021732537720B from "./5021732537720B.jpg";
import img5021732512918 from "./5021732512918.jpg";
import img5021732512918B from "./5021732512918B.jpg";
import img0603497818853 from "./0603497818853.jpg";
import img0603497818853B from "./0603497818853B.jpg";
import wa6 from "./wa6.jpg";
import wa10B from "./0603497820375B.jpg";
import wa10 from "./wa10.jpg";

const covers = [
  {
    ref: [img1],
    artist: "BOF",
    title: "The Virgin Suicides Deluxe (25th Anniversary Edition)",
    format: "LP + Flexi Disc",
    description:
      'Edition 25ème anniversaire de la bande originale du film The Virgin Suicides de Sofia Coppola. Inclus le hit "Playground Love" de Air ainsi que des titres de Todd Rundgren, Heart, Al Green et The Hollies.',
  },
  {
    ref: [img2, img2B],
    artist: "John Williams",
    title: "Harry Potter and The Philosopher's Stone",
    format: "2LP - Clear Vinyl",
    description:
      "Réédition vinyle transparent de la bande originale du film Harry Potter à l’école des sorciers sorti en 2001.",
  },
  {
    ref: [img3, img3B],
    artist: "John Williams",
    title: "Harry Potter and The Chamber of Secrets",
    format: "2LP - Clear Vinyl",
    description:
      "Réédition vinyle transparent de la bande originale du film Harry Potter et la Chambre des secrets sorti en 2002.",
  },
  {
    ref: [img5, img5B],

    artist: "John Williams",
    title: "Harry Potter and The Prisoner of Azkaban",
    format: "2LP - Clear Vinyl",
    description:
      "Réédition vinyle transparent de la bande originale du film Harry Potter et le Prisonnier d'Azkaban sorti en 2004.",
  },
  {
    ref: [img4, img4B],

    artist: "Patrick Doyle",
    title: "Harry Potter and The Goblet of Fire",
    format: "2LP - Clear Vinyl",
    description:
      "Réédition vinyle transparent de la bande originale du film Harry Potter et la Coupe de feu sorti en 2005.",
  },
  {
    ref: [img6, img6B],
    artist: "Klaus Doldinger & Giorgio Moroder",
    title: "The Never Ending Story",
    format: "LP - Starlight Vinyl",
    description:
      'Réédition vinyle de couleur de la bande originale du film l\'Histoire sans fin composée par Klaus Doldinger et produite par Giorgio Moroder. Inclus le tube "Never Ending Story" interprété par Limahl.',
  },
  {
    artist: "Bobby Charles",
    title: "Rarities",
    format: "LP",
    description:
      'Bobby Charles est un auteur compositeur né en Louisiane en 1938 connu pour ses classiques "See you Later", "Alligator" et "Walking to New Orleans". On retrouve sur cette compilation des titres rares enregistrés lors des sessions d\'enregistrement de son 1er album éponyme.',
    ref: [wa10, wa10B],
  },
  {
    artist: "Count Basie and His Orchestra",
    title: "Best of the Roulette Years",
    format: "LP - Green Vinyl - 180gr.",
    description:
      'Nouveau Best of regroupant les grands hits de Count Basie "Splanky", "Flight of the Foo Birds" et "One O’clock Jump".',
    ref: [wa6, img5021732537720B],
  },
  {
    artist: "Peter Tosh",
    title: "Greatest Hits",
    format: "LP - Red, Green and Yellow Vinyl",
    description:
      "Best of des années Parlophone. Inclus les classiques Johnny B. Goode, Wanted Dread and Alive et Bush Doctor.",
    ref: [img5021732512918, img5021732512918B],
  },
  {
    artist: "War",
    title: "Why can't we Be Friends (Ed Deluxe)",
    format: "3LP",
    description:
      'Réédition Deluxe 50ème anniversaire. Inclus les hits "Why can\'t we be Friends" et "Low Rider" + un vinyle de titres bonus. Album Remaster 2025.',
    ref: [img0603497818853, img0603497818853B],
  },
];

export default covers;
